/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Translate, I18n as I } from 'react-redux-i18n';
import LookupsHelper from 'lib/LookupsHelper';

import { Button, Tooltip } from 'antd';

import { isNil, PartyTypes } from 'vdlib';
import {
  NOTIFICATIONS_DROPDOWN_NAME,
  USER_PROFILE_DROPDOWN_NAME,
  MENU_DROPDOWN_NAME,
  LANGUAGES_DROPDOWN_NAME,
} from 'lib/Constants';
import logo from 'static/img/logo_slim.png';
import bronzeMembership from 'static/img/Bronze.png';
import silverMembership from 'static/img/Silver.png';
import goldMembership from 'static/img/Gold.png';
import platinumMembership from 'static/img/Platinum.png';
import trialMembership from 'static/img/Trial.png';

const logoStyle = {
  height: '43px',
  width: '170px',
  marginTop: 5,
  textAlign: 'center',
};

const imageStyle = {
  height: '24px',
  width: '24px',
  marginTop: 15,
  textAlign: 'center',
};

const membershipObjects = [
  { Title: 'Bronze', Image: bronzeMembership, Message: 'Bronze' },
  { Title: 'Silver', Image: silverMembership, Message: 'Silver' },
  { Title: 'Gold', Image: goldMembership, Message: 'Golden' },
  { Title: 'Platinum', Image: platinumMembership, Message: 'Platinum' },
  { Title: 'Trial', Image: trialMembership, Message: 'Trial' },
];

const SUPPORTED_LANGUAGES = [
  { name: 'el-GR', title: 'Ελληνικά' },
  { name: 'en-US', title: 'English' },
];

const visibleDropdownClassName = 'show';

const Header = ({
  language,
  languagesOpen,
  notificationsOpen,
  onlineAuctionsCount,
  partyTypes,
  setLocale,
  setShowOnline,
  showOnline,
  toggleHeaderDropdown,
  toggleHeaderMenu,
  user,
  userProfileOpen,
  memberships,
}) => {
  const openState = React.useRef({
    languagesOpen,
    notificationsOpen,
    userProfileOpen,
    showOnline,
    user,
  });

  const [membershipObject, setMembershipObject] = React.useState(null);

  React.useEffect(() => {
    openState.current = {
      languagesOpen,
      notificationsOpen,
      userProfileOpen,
      showOnline,
      user,
    };

    if (user)
      setMembershipObject(
        membershipObjects.find(
          x =>
            x.Title ===
            LookupsHelper.getDescription(memberships, user.MembershipId)
        )
      );
  }, [languagesOpen, notificationsOpen, userProfileOpen, showOnline, user]);

  const globalClick = React.useCallback(e => {
    if (openState.current.notificationsOpen)
      setTimeout(
        () => toggleHeaderDropdown(NOTIFICATIONS_DROPDOWN_NAME, false),
        50
      );
    else if (openState.current.userProfileOpen)
      setTimeout(
        () => toggleHeaderDropdown(USER_PROFILE_DROPDOWN_NAME, false),
        50
      );
    else if (openState.current.languagesOpen)
      setTimeout(
        () => toggleHeaderDropdown(LANGUAGES_DROPDOWN_NAME, false),
        50
      );
  }, []); //eslint-disable-line

  React.useEffect(() => {
    window.addEventListener('mouseup', globalClick, false);
  }, []); //eslint-disable-line

  const isMerchant = React.useMemo(
    () =>
      user &&
      user.PartyType ===
        LookupsHelper.getIdByDescription(partyTypes, PartyTypes.Merchant),
    [user, partyTypes]
  );

  const notificationsClassName =
      notificationsOpen === true ? visibleDropdownClassName : '',
    userProfileClassName =
      userProfileOpen === true ? visibleDropdownClassName : '',
    languagesClassName = languagesOpen === true ? visibleDropdownClassName : '';

  return (
    <div className="page-header navbar fixed-top">
      <div className="page-logo">
        <a href="javascript:;">
          <img src={logo} alt="logo" style={logoStyle} />
        </a>
      </div>

      <div className="top-menu">
        <ul className="nav navbar-nav float-right">
          {isMerchant && (
            <li className="dropdown languages-dropdown">
              <Button
                className={`online-auctions-button ${
                  onlineAuctionsCount > 0 ? 'active' : ''
                }`}
                type={showOnline ? null : 'primary'}
                size="small"
                danger
                style={{ marginTop: 14 }}
                onClick={() => setShowOnline(!showOnline)}
              >
                {showOnline
                  ? 'Hide LIVE'
                  : `Show LIVE${
                      onlineAuctionsCount === 0
                        ? ''
                        : ' (' + onlineAuctionsCount + ')'
                    }`}
              </Button>
            </li>
          )}

          <li className="dropdown languages-dropdown">
            <button
              className="btn dropdown-toggle"
              data-toggle="dropdown"
              data-hover="dropdown"
              data-close-others="true"
              onClick={() => toggleHeaderDropdown(LANGUAGES_DROPDOWN_NAME)}
            >
              <div className={'language language-' + language} />
              <i className="fa fa-angle-down" />
            </button>
            <ul
              className={`dropdown-menu dropdown-menu-right ${languagesClassName}`}
            >
              {SUPPORTED_LANGUAGES.map(lang => (
                <li key={'ref-lang-' + lang.name}>
                  <a href="#" onClick={() => setLocale(lang.name)}>
                    <div className={'language language-' + lang.name} />
                    <Translate value={lang.title} />
                  </a>
                </li>
              ))}
            </ul>
          </li>

          {isMerchant && membershipObject ? (
            <li className="dropdown languages-dropdown">
              <Tooltip title={`Membership: ${membershipObject.Message}`}>
                <img style={imageStyle} src={membershipObject.Image} alt="" />
              </Tooltip>
            </li>
          ) : null}

          <li className="dropdown dropdown-user">
            <button
              className="btn dropdown-toggle"
              data-toggle="dropdown"
              data-hover="dropdown"
              data-close-others="true"
              onClick={() => toggleHeaderDropdown(USER_PROFILE_DROPDOWN_NAME)}
            >
              <span className="username username-hide-on-mobile">
                {' '}
                {isNil(user) ? '' : user.Username}{' '}
              </span>
              <i className="fa fa-angle-down" />
            </button>
            <ul
              className={`dropdown-menu dropdown-menu-right ${userProfileClassName}`}
            >
              <li>
                <Link to="/userprofile">
                  <i className="fa fa-user" /> {I.t('PROFILE')}
                </Link>
              </li>
              <li>
                <Link to="/changepassword">
                  <i className="fa fa-key" /> {I.t('CHANGE_PASSWORD')}
                </Link>
              </li>
              <li className="dropdown-divider"> </li>
              <li>
                <Link to="/logout">
                  <i className="fa fa-power-off" />
                  {I.t('LOGOUT')}
                </Link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <a
        href="javascript:;"
        className="navbar-toggler collapsed menu-toggler responsive-toggler"
        data-toggle="menu"
        data-target=".navbar-collapse"
        onClick={() => toggleHeaderMenu(MENU_DROPDOWN_NAME)}
      >
        <span />
      </a>
    </div>
  );
};

Header.propTypes = {
  user: PropTypes.object,
};

export default Header;
